import { useHits } from 'react-instantsearch'
import CompanyCard from '@/components/card/CompanyCard'

export default function ListArchiveItems(): JSX.Element {
  const { items } = useHits()

  if (!items?.length) {
    return <p>No results could be found</p>
  }

  return (
    <ul className="mb-l flex flex-col gap-y-s">
      {items.map((item) => (
        <CompanyCard key={item.objectID} item={item} />
      ))}
    </ul>
  )
}
